import { createAuthClient } from "better-auth/react";
import { stripeClient } from "@better-auth/stripe/client";
import { inferAdditionalFields, organizationClient, emailOTPClient, inferOrgAdditionalFields } from "better-auth/client/plugins";
import { env } from "@env";

export const authClient = createAuthClient({
  baseURL: env.VITE_API_BASE_URL,
  basePath: "/auth",
  fetchOptions: {
    credentials: "include",
  },
  plugins: [
    inferAdditionalFields({
      user: {
        first_name: {
          type: "string",
          required: false,
        },
        onboarding: {
          type: "string",
          required: false,
        },
      },
    }),
    stripeClient({
      subscription: true,
    }),
    organizationClient({
      schema: inferOrgAdditionalFields({
        organization: {
          additionalFields: {
            timezone: {
              type: "string",
              input: true,
            },
            country: {
              type: "string",
              input: true,
            },
            city: {
              type: "string",
              input: true,
            },
            postal_code: {
              type: "string",
              input: true,
            },
            phoneNumber: {
              type: "string",
              input: true,
            },
            clubEmail: {
              type: "string",
              input: true,
            },
          },
        },
      }),
    }),
    emailOTPClient(),
  ],
});
